/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class Course {
  baseApi = ENV.BASE_API;

  async getCourses(params) {
    try {
      const pageFilter = `page=${params?.page || 1}`;
      const limitFilter = `limit=${params?.limit || 10}`;
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}?${pageFilter}&${limitFilter}`;
      const response = await fetch(url);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createCourse(accessToken, data) {
    try {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
      if (data.file) {
        formData.append("miniature", data.file);
      }
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateCourse(accessToken, idCourse, data) {
    try {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
      if (data.file) {
        formData.append("miniature", data.file);
      }
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}/${idCourse}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteCourse(accessToken, idCourse) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}/${idCourse}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getCoursesByStudent(accessToken, studentId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}/${studentId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async saveClassAdvancement(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}/saveClassAdvancement`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async saveEvaluation(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}/saveEvaluation`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateCourseGrades(accessToken, courseId, gradesData) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}/${courseId}/grades`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(gradesData),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Gets courses by academic cycle, subject and grade for grade registration.
   * @param {string} accessToken - JWT token
   * @param {number} academicCycleId - Academic cycle ID
   * @param {number} subjectId - Subject ID
   * @param {number} gradeId - Grade ID
   * @returns {Promise<Array>} - List of courses with student info
   */
  async getCoursesByAcademicCycleAndSubjectGrade(
    accessToken,
    academicCycleId,
    subjectId,
    gradeId,
  ) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.COURSE}/academic-cycle/${academicCycleId}/subject/${subjectId}/grade/${gradeId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result.data || result;
    } catch (error) {
      throw error;
    }
  }
}
